import { DetailOptions } from '.';
import { DetailBase } from './detail-base.component';
export class DetailModel<TModel> extends DetailBase<TModel> {
  constructor(options: DetailOptions<TModel>) {
    super(options);
  }
}
